import React, { ReactElement } from 'react';
import { SortSelect } from 'slovlex-idsk-react-components';

const PublikovanyTerminListSort = (): ReactElement => (
  <SortSelect
    sortList={[
      { sort: 'terminSort', sortBy: 'asc', title: 'Termín (A-Z)' },
      { sort: 'terminSort', sortBy: 'desc', title: 'Termín (Z-A)' },
      { sort: 'preferovanyTerminSort', sortBy: 'asc', title: 'Preferovaný termín (A-Z)' },
      { sort: 'preferovanyTerminSort', sortBy: 'desc', title: 'Preferovaný termín (Z-A)' },
      { sort: 'tezaurus', sortBy: 'asc', title: 'Tezaurus (A-Z)' },
      { sort: 'tezaurus', sortBy: 'desc', title: 'Tezaurus (Z-A)' },
    ]}
  />
);

export default PublikovanyTerminListSort;
